var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{on:{"cancel":function($event){return _vm.cancel()},"password-changed":function($event){return _vm.passwordChanged($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }